import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {put, api, getUser, consts} from '@config';

const user = getUser()

import Tour, { ReactTourContent } from "../theme/tour";

class PosTour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      abc: ""
    };
  }

  onCloseTour() {
    const url = `${api.users.register}${user.id}/`;
    const data = {
      pos_tour: true, 
      email: user.email,
      timezone: "America/Belem"
    };
    const payload = resp => {
      window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp)); 
    };
    put(url, data, payload);
  }

  UNSAFE_componentWillMount() {}
  render() {
    return (
      <Tour
      onCloseTour={() => this.onCloseTour()}
        badgeVerbose
        steps={[
          {
            selector: "container-fluid",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent
                title="Ponto de vendas"
                goTo={goTo}
                inDOM={inDOM}
                step={step}
              >
                <p>
                  Agora que você já tem filial e produtos cadastrados está na hora de vender!
                </p>
                <p>
                  Para que você possa vender sem nenhuma dor de cabeça, desenvolvemos um PDV (Ponto de vendas) cheio de funções que irão facilitar sua vida.
                </p>
                <h4>Vamos começar! Clique em próximo</h4>
              </ReactTourContent>
            )
          },
          {
            selector: "#input-search-product",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2 className="text-center pb-1">Pesquisar produto</h2>
                <p>
                  Aqui é onde você irá buscar os seus produtos para vendê-los.
                  Você pode buscá-los pelo: nome, código interno, e também pelo
                  código de barras
                </p>
                <p>
                  Pensando em praticidade, nos criamos algumas facilidades na
                  hora de vender seus produtos, por exemplo:{" "}
                </p>
                <p>
                  O cliente vai levar 10 unidsdes do mesmo produto, para
                  facilicar basta inserir: 10*<strong>789000912367</strong>,
                  assim dez unidades do produto com código de barras{" "}
                  <strong>789000912367</strong> serão adicionados a venda
                </p>
              </ReactTourContent>
            ),
            action: node => node.focus()
          },
          {
            selector: "[data-list-products]",
            position: [window.screen.width / 2, window.screen.height / 4],
            content: ({ goTo, inDOM, step }) => {
              return <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2>Lista de Produtos</h2>
                <p>
                  Aqui é onde os produtos selecionados são listados, podendo ser
                  removidos.
                </p>
                <p>
                  Aqui esté seu primeiro produto cadastrado. Vamos ver como vendê-lo?
                </p>
              </ReactTourContent>
            }
          },
          {
            selector: "[data-resume]",
            position: "top",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2>Informações da venda</h2>
                <p>
                  Informações básicas da venda como o total das compras e o
                  desconto, se houver.
                </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-client]",
            position: "top",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2>Cliente</h2>
                <p>
                  Este botão permite que o vendendor cadastre e/ou selecione um
                  cliente.
                </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-discount]",
            position: "top",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2>Descontos</h2>
                <p>
                  Aqui é onde o vendedor poderá dar descontos em %(porcentagem)
                  ou não;
                </p>
              </ReactTourContent>
            )
          },
          {
            selector: "[data-confirm-sale]",
            position: "top",
            content: ({ goTo, inDOM, step }) => (
              <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
                <h2>Confirmar a venda</h2>
                <p>
                  Após todos os produtos serem selecionados o vendedor virá a
                  esse botão para confirmar a venda
                </p>
                <h4>
                  OBS: Esse botão só se ativará quando houver ao menos um
                  produto selecionado.
                </h4>
                <Link className="btn btn-primary btn-block" to="/pos/payment">
                  Pagamento
                </Link>
              </ReactTourContent>
            )
          }
        ]}
      ></Tour>
    );
  }
  componentWillUnmount() {}
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(PosTour);



// WEBPACK FOOTER //
// ./src/components/tours/pos-tour.jsx